export default "__VITE_ASSET__BI0t2eeZ__"